import React from "react";
import { Link } from "react-router-dom";

import styled, { css } from "styled-components";

import Image from "components/atoms/Image";
import Text from "components/atoms/text/Text";

import { useDevice } from "utils/device";

const Container = styled.div`
    box-sizing: border-box;
    padding: 40px 40px 48px 40px;
    width: 100%;
    background-color: var(--color-Black);
`;

const TopLine = styled.div`
    margin-bottom: 40px;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;

    ${(props) =>
        props.$device.isPC &&
        css`
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        `};
`;

const LeftSide = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 40px 0 0 0;

    ${(props) =>
        props.$device.isPC &&
        css`
            flex-direction: row;
            margin: 0;
        `};
`;

const InfoSection = styled.div`
    ${(props) =>
        props.$device.isTabletOrPC &&
        css`
            margin-right: 80px;
        `};
`;

const ContactSection = styled.div`
    margin: 40px 0 0 0;

    ${(props) =>
        props.$device.isPC &&
        css`
            margin: 0;
        `};
`;

const BottomLine = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    ${(props) =>
        props.$device.isTabletOrPC &&
        css`
            flex-direction: row;
            align-items: center;
        `};
`;

const TermsWrap = styled.div`
    display: flex;
    align-items: center;
`;

const secTitleStyle = {
    variant: "title-sm-500",
    margin: "0 0 20px 0",
    fontWeight: "bold",
    color: "var(--color-Grey1)",
};

const mobileInfoSecStyle = {
    variant: "body-sm-400",
    margin: "4px 0 0 0",
    color: "var(--color-Grey1)",
};

const termTextBtnTabletOrPCStyle = {
    variant: "body-md-400",
    margin: "0 16px 0 0",
    fontWeight: "medium",
    color: "var(--color-Grey1)",
};

const termTextBtnMobileStyle = {
    variant: "body-sm-400",
    margin: "0 8px 0 0",
    fontWeight: "medium",
    color: "var(--color-Grey1)",
};

const InfoSecText = styled(Text).attrs({
    variant: "body-md-400",
    color: "var(--color-Grey2)",
})``;

function PageFooter(props) {
    const device = useDevice();
    const termTextBtnStyle = device.isTabletOrPC ? termTextBtnTabletOrPCStyle : termTextBtnMobileStyle;

    return (
        <Container>
            <TopLine $device={device}>
                <LeftSide $device={device}>
                    {device.isTabletOrPC ? (
                        <InfoSection $device={device}>
                            <Text {...secTitleStyle}>COMPANY INFO</Text>
                            <InfoSecText>
                                상호명 : (주) 데이탄소프트 | 사업자번호 : 326-88-01855 | 통신판매업 신고번호 : 제
                                2022-제주연동-0076-호
                                <br />
                                주소 : 제주특별자치도 제주시 도령북길 31, 2층 데이탄소프트 | 대표이사 : 명재석
                            </InfoSecText>
                        </InfoSection>
                    ) : (
                        <InfoSection $device={device}>
                            <Text {...secTitleStyle}>COMPANY INFO</Text>
                            <Text {...mobileInfoSecStyle}>상호명 : (주) 데이탄소프트</Text>
                            <Text {...mobileInfoSecStyle}>사업자번호 : 326-88-01855</Text>
                            <Text {...mobileInfoSecStyle}>통신판매업 신고번호 : 제 2022-제주연동-0076-호</Text>
                            <Text {...mobileInfoSecStyle}>
                                주소 : 제주특별자치도 제주시 도령북길 31, 2층 데이탄소프트
                            </Text>
                            <Text {...mobileInfoSecStyle}>대표이사 : 명재석</Text>
                        </InfoSection>
                    )}
                    <ContactSection $device={device}>
                        <Text {...secTitleStyle}>CONTACT</Text>
                        {device.isTabletOrPC ? (
                            <InfoSecText>
                                전화번호 : 064-713-9844
                                <br />
                                이메일 주소 : prep@datansoft.com
                            </InfoSecText>
                        ) : (
                            <>
                                <Text {...mobileInfoSecStyle}>전화번호 : 064-713-9844</Text>
                                <Text {...mobileInfoSecStyle}>이메일 주소 : prep@datansoft.com</Text>
                            </>
                        )}
                    </ContactSection>
                </LeftSide>
                <Image name={"footerLogo"} />
            </TopLine>
            <BottomLine $device={device}>
                <TermsWrap>
                    <Link to={"/terms-of-service"} target="_blank">
                        <Text {...termTextBtnStyle}>이용약관</Text>
                    </Link>
                    <Link to={"/privacy-policy"} target="_blank">
                        <Text {...termTextBtnStyle}>개인정보 처리방침</Text>
                    </Link>
                </TermsWrap>
                <Text
                    variant={device.isTabletOrPC ? "body-md-400" : "body-sm-400"}
                    margin={device.isTabletOrPC ? "initial" : "10px 0 0 0"}
                    fontWeight={"medium"}
                    color={"var(--color-Grey2)"}
                >
                    (C) DataNSoft Inc. All right reserved.
                </Text>
            </BottomLine>
        </Container>
    );
}

export default PageFooter;
